import { render, staticRenderFns } from "./AboutApp.vue?vue&type=template&id=f396460a"
import script from "./AboutApp.vue?vue&type=script&lang=js"
export * from "./AboutApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports